// @ts-nocheck   ← ignore TS in this file
import { Amplify } from "aws-amplify";


// Get AppSync endpoint from environment or use fallback for development
const appSyncEndpoint = "https://wdlmiri2vbchbki3s3nzj7l4d4.appsync-api.us-east-1.amazonaws.com/event";

Amplify.configure({
    Auth: {
        region: "us-east-1",
        Cognito: {
            identityPoolId: "us-east-1:19082c06-2f5b-45c1-88d6-fb51b3cd3d6b",
            allowGuestAccess: true,
        }
    },

    // real-time AppSync (Events category)
    API: {
        Events: {
            endpoint: appSyncEndpoint,
            region: "us-east-1",
            defaultAuthMode: "iam",
        }
    },

    Logging: {
        level: "DEBUG"
    }
});